import { c as _c } from "react/compiler-runtime";
import { RichTextRenderer } from "../../utils/RichTextRenderer";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { SpecialButton } from "../../component/SpecialButton/SpecialButton";
export interface FAQItem {
  headline?: string;
  description?: any;
  ctaLink?: {
    label: string;
    destination: string;
  };
}
export const FAQItem = t0 => {
  const $ = _c(10);
  const {
    headline,
    description,
    ctaLink
  } = t0;
  let t1;
  if ($[0] !== headline) {
    t1 = <div className="flex items-center"><span className="text-lg font-bold leading-7 mb-3">{headline}</span></div>;
    $[0] = headline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description && <CommonDescription description={description?.props?.data?.content ? <RichTextRenderer raw={description.props.data.content.raw} references={description.props.data.content.references} componentClass="t2-accordion-content" /> : description} className="t2-faq-item__description t2-layout__description" />;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ctaLink) {
    t3 = ctaLink && <SpecialButton label={ctaLink.label} destination={ctaLink.destination} primary={false} />;
    $[4] = ctaLink;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="t2-faq-item mb-6">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};